function addEvents() {
    let navigationButton = document.querySelector(".sitenav > button");
    let navigationOverlay = document.querySelector(".sitenav > .sitenav-overlay");

    let toggle = false;
    if (navigationButton) {
        navigationButton.addEventListener("click", function () {
            toggle = !toggle;
            if (toggle) {
                navigationButton.classList.add("is-arrow");
                navigationOverlay.classList.add("is-visible");
            } else {
                navigationButton.classList.remove("is-arrow");
                navigationOverlay.classList.remove("is-visible");
            }
        });
    }

    let subMenuToggles = document.querySelectorAll(".sitenav .sitenav-toggle");
    subMenuToggles.forEach(function (subMenuToggle) {
        subMenuToggle.addEventListener("click", function () {
            let menuItem = subMenuToggle.closest(".sitenav-item");
            if (menuItem) {
                let isExpanded = menuItem.classList.toggle("is-expanded");
                subMenuToggle.setAttribute("aria-expanded", isExpanded ? "true" : "false");
            }
        });
    });
}

//document ready in plain javascript
if (document.readyState === "complete" || (document.readyState !== "loading" && !document.documentElement.doScroll)
) {
    addEvents();
} else {
    document.addEventListener("DOMContentLoaded", addEvents);
}